import { Form, Row, Col, Typography, Input, Button, Alert } from "antd";
import React, { useState } from "react";
import { GenerateLogo } from "../logoHelpers";
import http from "../../../../../utils/http";
import { useSelector } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router";

import newsletterAdImage from '../../../../../static/newsletter-woman.jpg';

const { Title, Paragraph } = Typography;

function NewsletterForm(props) {
  const [form] = Form.useForm();
  const companyId = useSelector((state) => state.companyConfig.company_id);
  const vertical = useSelector((state) => state.companyConfig.vertical_id);
  const [isLoading, setIsLoading] = useState(false);
  const [isAlreadySubscribed, setIsAlreadySubscribed] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const history = useHistory();

  const subscribe = () => {
    setIsLoading(true);
    setIsSuccess(false);
    setIsAlreadySubscribed(false);
    setTimeout(() => {
      form
        .validateFields()
        .then(async (data) => {
          try {
            const response = await http.post(
              `gastro/${companyId}/subscription`,
              {
                full_name: data.userName,
                email: data.userEmail,
              }
            );
            if (response.data.payload.user_id) {
              setIsSuccess(true);
              window.localStorage.setItem("_dn", moment.utc().valueOf());
              if (vertical === 3) {
                history.push('/public/welcome/form/menu');
              } else {
                history.push('/public/welcome/form');
              }
            }
            setIsLoading(false);
          } catch (error) {
            if (error.response.data.error.type === "email_exists") {
              setIsAlreadySubscribed(true);
            } else {
              console.log("====================================");
              console.log("Unable to subscribe: ", error);
              console.log("====================================");
            }
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log("====================================");
          console.log("Fields contain errors: ", error);
          console.log("====================================");
          setIsLoading(false);
        });
    }, 1500);
  };

  return (
    <div className="newsletter-form-wrapper">
      <Row className="newsletter-bg">
        <Col xs={0} lg={8}></Col>
        <Col xs={24} lg={8}>
          <Row>
            <Col xs={24}>
              <div className="newsletter-logo-wrapper">
                <GenerateLogo className="newsletter-logo" />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <Title level={4} className="m-t-24">
                Abonniere Sie unseren Newsletter
              </Title>
              <Paragraph>
                Durch abonnieren unseres Newsletters bekommen Sie Zugang zu unseren
                exklusiven Angeboten & Aktionen in unserem Restaurant. Eine enge
                Verbindung zu Ihnen ist uns wichtig und daher werden wir Ihre Daten
                vertrauensvoll behandeln und für keinerlei anderen Zwecke verwenden.
                Hiermit bestätigen Sie die AGBs und Datenschutz gelesen zu haben und
                diese zu akzeptiert.
              </Paragraph>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <div className="m-b-12">
                {isAlreadySubscribed && (
                  <Alert
                    message="Das Abonnieren hat nicht funktioniert."
                    description="Diese E-Mail-Adresse wurde bereits verwendet."
                    type="error"
                    showIcon
                  />
                )}
                {isSuccess && (
                  <Alert
                    message="Sie sind abonniert!"
                    description="Danke, dass Sie unseren Newsletter abonniert haben."
                    type="success"
                    showIcon
                  />
                )}
              </div>
              <Form form={form} preserve={false} layout="vertical">
                <Form.Item
                  label="Name"
                  name="userName"
                  required
                  rules={[
                    { required: true, message: "Bitte geben Sie Ihren Namen ein." },
                  ]}
                >
                  <Input type="text" placeholder="John Doe" />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="userEmail"
                  rules={[
                    { required: true, message: "Please enter your email." },
                    { type: "email", message: "Bitte geben Sie Ihre E-Mail ein." },
                  ]}
                  required
                >
                  <Input type="email" placeholder="you@welcomy.co" />
                </Form.Item>
              </Form>
              <Button type="primary" size="large" onClick={subscribe} block loading={isLoading}>
                Jetzt abonnieren
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs={0} lg={8}>
          <div className="newsletter-ad">
            <div className="newsletter-ad__content-wrapper">
              <img src={newsletterAdImage} alt="A happy person receiving a newsletter notificaiton" />
              <div className="newsletter-ad__text">
                <Title level={3} className="newsletter-ad__title">
                  Bleiben Sie auf dem neuesten Stand
                </Title>
                <Paragraph className="newsletter-ad__subtitle">Abonnieren Sie jetzt, um relevante Neuigkeiten zu erhalten.</Paragraph>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default NewsletterForm;
